import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import PharmacyInvoicePage from "pages/invoice/pharmacyInvoice";
import { fetchWholesalers } from "utils/apiHelper";
import CreateSupplierModal from './CreateSupplierModal';
import useAuth from 'hooks/useAuth';

export default function SaleInvoice() {
    const { roles = [], isAdmin } = useAuth();
    const navigate = useNavigate();
    const saleBillsReadOnly = roles.includes('pharmacy_biller') && !(isAdmin || roles.includes('superuser') || roles.includes('pharmacy_store_manager') || roles.includes('account_manager'));
    const [wholesalerModalOpen, setWholesalerModalOpen] = useState(false);
    const [wholesalerEditModalOpen, setWholesalerEditModalOpen] = useState(false);
    const [selectedWholesaler, setSelectedWholesaler] = useState(null);
    const [wholesalersList, setWholesalersList] = useState([]);

    const fetchWholesalersData = useCallback(async () => {
        const response = await fetchWholesalers('limit=100000');
        setWholesalersList(response?.results || []);
    }, []);

    const handleWholesalerModalClose = () => {
        setWholesalerModalOpen(false);
        fetchWholesalersData();
    };

    const handleWholesalerEditModalClose = () => {
        setWholesalerEditModalOpen(false);
        fetchWholesalersData();
        setSelectedWholesaler(null);
    };

    useEffect(() => {
        if (saleBillsReadOnly) {
            navigate('/inventory/sale-bills');
            return;
        }
        fetchWholesalersData();
    }, [saleBillsReadOnly, navigate, fetchWholesalersData]);

    return (
        <>
            <Breadcrumbs custom heading="Create Sale Bill" />
            <PharmacyInvoicePage
                variant="sale"
                setWholesalerEditModalOpen={setWholesalerEditModalOpen}
                setWholesalerModalOpen={setWholesalerModalOpen}
                setSelectedWholesaler={setSelectedWholesaler}
                selectedWholesaler={selectedWholesaler}
                wholesalersList={wholesalersList}
            />
            <CreateSupplierModal
                open={wholesalerModalOpen}
                modalToggler={handleWholesalerModalClose}
                mode="create"
            />
            <CreateSupplierModal
                open={wholesalerEditModalOpen}
                modalToggler={handleWholesalerEditModalClose}
                mode="edit"
                supplierData={selectedWholesaler}
            />
        </>
    );
}